/**
 * this is the footer component
 *
 * Created by Tom on 31/5/17
 */

import React, {Component} from 'react'
import PropTypes from 'prop-types'
import {bindActionCreators} from 'redux'
import {connect} from 'react-redux'

import config from '../../config'

// action import
import {ActionCreator} from '../../actions/'

// component import
import AppButton from '../AppButton/'
import AppLink from '../AppLink'

// style import
import './style.scss'


class Footer extends Component {

    _signOutClick() {
        console.log('Sign Out')
    }

    render() {
        return (
            <div className="footer">

                {/* sign out button */}
                <div className="footer__sign-out-button">
                    <AppLink
                        isExternal={true}
                        route={config.endpoints.websiteSignOutURL}>
                        <AppButton
                            buttonText="SIGN OUT"
                            onClick={::this._signOutClick}
                            size="big"
                            color="blue"/>
                    </AppLink>
                </div>
                {/* text container */}
                <div className="footer__text_container">
                    <AppLink
                        className="footer__links footer__terms"
                        route={config.endpoints.websiteTermsURL}
                        isExternal={true}
                        openInNewTab={true}>
                        Terms & conditions
                    </AppLink>
                    <AppLink
                        className="footer__links footer__privacy"
                        route={config.endpoints.websitePrivacyPolicyURL}
                        isExternal={true}
                        openInNewTab={true}>
                        Privacy policy
                    </AppLink>
                </div>
            </div>
        )
    }
}

// define the prop types
Footer.propTypes = {
    goToRoute: PropTypes.func.isRequired
}

// pull all required action creators into this container
const mapDispatchToProps = (dispatch) => {
    const action = bindActionCreators(ActionCreator, dispatch)
    return {
        goToRoute: action.goToRoute
    }
}

export default connect(null, mapDispatchToProps)(Footer)



// WEBPACK FOOTER //
// ./src/components/Footer/index.js